var exports = {
  "DD": "xb99ab02a--817f12--title",
  "VA": "xb99ab02a--817f12--subtitle",
  "hJ": "xb99ab02a--817f12--counter",
  "K9": "xb99ab02a--817f12--projects-link",
};

module.exports = exports;
